import { IListViewField } from "src/components/Shared/ILIstViewField";
import { DocumentListViewDefaultToolbarButtons } from "src/components/Shared/ListViews/DocumentListViewDefaultToolbarButtons";
import { DocumentListViewToolbar } from "src/components/Shared/ListViews/DocumentListViewToolbar";
import { ListView } from "src/components/Shared/ListViews/ListView";
import { ListviewToolbarMoreActions } from "src/components/Shared/ListViews/ListviewToolbarMoreActions";
import { AppEntities } from "src/config/entities";

const AssemblyDisassemblyOfGoodsList = () => {
  const fields: IListViewField[] = [
    {
      title: "Company",
      fieldName: "companyName"
    },
    {
      title: "Warehouse",
      fieldName: "warehouseName"
    },
    {
      title: "Division",
      fieldName: "divisionName"
    },
    {
      title: "Operation",
      fieldName: "operationTypeName"
    }
  ];

  return (
    <>
      <ListView
        // createDocumentActions={createDocumentActions}
        fields={fields}
        entity={AppEntities.AssemblyDisassemblyOfGoods}
        // createDependedDocumentActions={createDocumentActions}
        createMoreActions={[]}
      >
        <DocumentListViewToolbar>
          <DocumentListViewDefaultToolbarButtons />
          {/* <ListviewToolbarSubmenuButton /> */}
          {/* </DocumentListViewDefaultToolbarButtons> */}
          <ListviewToolbarMoreActions />
        </DocumentListViewToolbar>
      </ListView>
    </>
  );
};

export default AssemblyDisassemblyOfGoodsList;
